import { useCallback } from 'react';
import { Button, ButtonSizes, ButtonVariants, TableCellTypes } from '@carboledger/ui';
import { makeSerialCell } from '@/components/common';
import { buildActivityModuleVariants } from './activityModules';
import { ACTIVITY_MODULE_TONE } from './adminTones';
import { ACTIVITY_COLUMNS, ACTIVITY_SORT_FIELDS } from './admin.constants';

const canSort = (id) => Boolean(ACTIVITY_SORT_FIELDS[id]);

/**
 * Props:
 *   row     the activity; `actionTo` is where its CTA leads, `actionLabel` the server's copy
 *   onOpen  (row) => void
 */
const ActivityActionCell = ({ row, onOpen }) => {
  const handleClick = useCallback(() => onOpen(row), [onOpen, row]);

  if (!row.actionTo) return null;

  return (
    <Button variant={ButtonVariants.tertiary} size={ButtonSizes.sm} onClick={handleClick}>
      {row.actionLabel}
    </Button>
  );
};

const makeActionCell = (onOpen) => {
  const renderAction = (ctx) => <ActivityActionCell row={ctx.row} onOpen={onOpen} />;
  return renderAction;
};

export const buildActivityLogColumns = (t, { serialOffset = 0, onOpenAction }) =>
  [
    {
      id: ACTIVITY_COLUMNS.serialNo,
      header: t('FIELD_SERIAL_NO'),
      type: TableCellTypes.custom,
      width: 80,
      cell: makeSerialCell(serialOffset),
    },
    {
      id: ACTIVITY_COLUMNS.dateTime,
      header: t('FIELD_DATE_TIME'),
      type: TableCellTypes.date,
      width: 180,
    },
    {
      id: ACTIVITY_COLUMNS.module,
      header: t('FIELD_MODULE'),
      type: TableCellTypes.badge,
      width: 150,
      variantMap: buildActivityModuleVariants(t, ACTIVITY_MODULE_TONE),
    },
    {
      id: ACTIVITY_COLUMNS.user,
      header: t('FIELD_USER'),
      type: TableCellTypes.text,
      width: 300,
    },
    {
      id: ACTIVITY_COLUMNS.activity,
      header: t('FIELD_ACTIVITY'),
      type: TableCellTypes.text,
      minWidth: 420,
    },
    {
      id: ACTIVITY_COLUMNS.action,
      header: t('FIELD_ACTION'),
      type: TableCellTypes.custom,
      width: 220,
      cell: makeActionCell(onOpenAction),
    },
  ].map((column) => ({ ...column, sortable: canSort(column.id) }));
